export const GET_APPLIED_JOB_REQUEST = "GET_APPLIED_JOB_REQUEST";
export const GET_APPLIED_JOB_SUCCESS = "GET_APPLIED_JOB_SUCCESS";
export const GET_APPLIED_JOB_FAIL = "GET_APPLIED_JOB_FAIL";

export const GET_ALL_JOB_REQUEST = "GET_ALL_JOB_REQUEST";
export const GET_ALL_JOB_SUCCESS = "GET_ALL_JOB_SUCCESS";
export const GET_ALL_JOB_FAIL = "GET_ALL_JOB_FAIL";
